import React from "react";
import * as SubframeCore from "@subframe/core";
import { Badge } from "subframe/components/Badge";

interface SurveyQuestionProps {
  question: string;
  score: string;
  sentiment: string;
  category?: string;
  flagged?: boolean;
  type?: string;  
  showFlagged?: boolean;
}

export const SurveyQuestion: React.FC<SurveyQuestionProps> = ({
  question,
  score,
  sentiment,
  category,
  flagged = false,
  type,
  showFlagged = false
}) => {
  showFlagged = showFlagged && sentiment === 'negative';
  const getSentimentConfig = (sentiment: string) => {
    switch (sentiment) {
      case 'low':
      case 'negative':
        return {
          borderColor: 'border-error-100',
          bgColor: 'bg-error-50',
          textColor: 'text-error-700',
          scoreColor: 'text-[#991b1bff]'
        };
      case 'medium':
      case 'neutral':
        return {
          borderColor: 'border-warning-100',
          bgColor: 'bg-warning-50',
          textColor: 'text-warning-800',
          scoreColor: 'text-[#854d0eff]'
        };
      case 'high':
      case 'positive':
        return {
          borderColor: 'border-success-100',
          bgColor: 'bg-success-50',
          textColor: 'text-success-800',
          scoreColor: 'text-[#166534ff]'
        };
      default:
        return {
          borderColor: 'border-neutral-100',
          bgColor: 'bg-neutral-100',
          textColor: 'text-neutral-700',
          scoreColor: 'text-neutral-700'
        };
    }
  };

  const config = getSentimentConfig(sentiment);
  const hasSentiment = sentiment && sentiment !== 'neutral' && sentiment !== '' && sentiment !== null;

  return (
    <div className="flex w-full flex-col items-start border-b border-solid border-neutral-border px-1 py-1">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full">
        <div className="flex flex-col gap-1 w-full sm:flex-1">
          <span className="w-full text-body font-body text-default-font">
            {question}
          </span>

        </div>
        <div className="flex items-center gap-2 self-start sm:self-center">
          {flagged && showFlagged && (
            <Badge variant="error" className="text-xs">
              Flagged
            </Badge>
          )}
          {hasSentiment ? (
            <div className={`flex h-6 items-center gap-1 rounded-md border border-solid ${config.borderColor} ${config.bgColor} px-2`}>
              <SubframeCore.Icon
                className={`text-label font-label ${config.textColor}`}
                name={null}
              />
              <span className={`whitespace-nowrap text-label font-label ${config.scoreColor}`}>
                {score} {sentiment === 'low' || sentiment === 'negative' ? 'Low' :
                  sentiment === 'medium' || sentiment === 'neutral' ? 'Medium' :
                    sentiment === 'high' || sentiment === 'positive' ? 'High' : 'Neutral'}
              </span>
              <SubframeCore.Icon
                className={`text-label font-label ${config.textColor}`}
                name={null}
              />
            </div>
          ) : (
            type !== 'free_response' && (
              <div className="flex h-6 items-center gap-1 rounded-md border border-solid border-neutral-100 bg-neutral-100 px-2">
                <span className="whitespace-nowrap text-label font-label text-neutral-700">
                  {score}
                </span>
              </div>
            )
          )}
        </div>
      </div>
      {type === 'free_response' && (
        <span className="w-full text-body font-body text-subtext-color">
          &quot;{score}&quot;
        </span>
      )}
    </div>
  );
}; 